import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from 'uApp/app.component';
import { appConfig } from 'uApp/app.config';

bootstrapApplication(AppComponent, appConfig).then(ref => {
  // Ensure Angular destroys itself on hot reloads.
  const ngRef = (window as { [key: string]: any })['ngRef'];
  if (ngRef) {
    ngRef.destroy();
  }
  (window as { [key: string]: any })['ngRef'] = ref;

  // Otherwise, log the boot error
}).catch(e => console.error(e));
